import { render, staticRenderFns } from "./index_h5.vue?vue&type=template&id=2801780c&scoped=true&"
import script from "./index_h5.vue?vue&type=script&lang=js&"
export * from "./index_h5.vue?vue&type=script&lang=js&"
import style0 from "./index_h5.vue?vue&type=style&index=0&id=2801780c&lang=less&scoped=true&"
import style1 from "./index_h5.vue?vue&type=style&index=1&id=2801780c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2801780c",
  null
  
)

export default component.exports